import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// Default 404 fallback. Renders inside RootLayout's Outlet so analytics
// and error tracking still fire for unknown URLs.
export function RouteNotFound(): ReactElement {
    const { t } = useTranslation();
    return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h5" gutterBottom>
                {t('ERRORS.NOT_FOUND.TITLE')}
            </Typography>
            <Button variant="outlined" component={Link} to="/new-requests" sx={{ mt: 1 }}>
                {t('ACTIONS.GO_HOME')}
            </Button>
        </Box>
    );
}
